<div class="content d-flex flex-column vi-gap-24">
  <headline-text [headline]="'APPOI.MESSAGE_RECEIVED.HEADLINE' | translate"
                 [text]="'APPOI.MESSAGE_RECEIVED.DESCRIPTION' | translate"
  ></headline-text>
  <div>
    <mat-card>
      <mat-card-content>
        <h3>{{ 'APPOI.MESSAGE_RECEIVED.SUMMARY.HEADLINE' | translate }}</h3>
        <section *ngIf="comment.typeOfRequest">
          <div><span class="semiBold">{{ 'APPOI.MESSAGE_RECEIVED.SUMMARY.REASON' | translate }}</span></div>
          <div><span class="muted">{{ comment.typeOfRequest }}</span></div>
        </section>
        <section *ngIf="comment.desiredDate">
          <div><span class="semiBold">{{ 'APPOI.MESSAGE_RECEIVED.SUMMARY.DESIRED_DATE' | translate }}</span></div>
          <div><span class="muted">{{ comment.desiredDate | date : 'mediumDate': timezone : locale }}</span></div>
        </section>
        <section *ngIf="comment.description">
          <div><span class="semiBold">{{ 'APPOI.MESSAGE_RECEIVED.SUMMARY.DESCRIPTION' | translate }}</span></div>
          <div><span class="muted">{{ comment.description }}</span></div>
        </section>
      </mat-card-content>
      <mat-card-actions *ngIf="embedModeEnabled">
        <button (throttledClick)="closeFrameEvent()"
                [throttleTime]="5000"
                appPreventDoubleClick
                class="vi-button"
                color="primary"
                mat-flat-button>{{ 'APPOI.BUTTON.CLOSE' | translate }}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
  <ng-container *ngIf="!embedModeEnabled">
    <viessmann-home-banner *ngIf="appointment.businessPartnerIsEndUser && settings.showLinkToViessmannHome"
                           [appointmentId]="appointment.id" [factoryId]="appointment.factoryId"
    ></viessmann-home-banner>
    <div *ngIf="!appointment.businessPartnerIsEndUser && settings.showLinkToHeatingSystemsOverview" class="actions">
      <button-heating-systems-overview [installation]="appointment.installation"></button-heating-systems-overview>
    </div>
  </ng-container>
</div>
